const transferTransportModes = [
  "rapidTransit",
  "underground",
  "tube",
  "walk",
  "transfer"
];
const isTransferLeg = ({ origin, destination, transportMode, transportModeName }) => !!((transferTransportModes.includes(transportMode == null ? void 0 : transportMode.mode) || transferTransportModes.includes(transportModeName)) && origin && destination);
var isTransferLeg_default = isTransferLeg;
export {
  isTransferLeg_default as default
};
